import React, { useState, useEffect, useRef } from 'react';

function TodoForm(props) {
  const [input, setInput] = useState(props.edit ? props.edit.value : '');
  const [priority, setPriority] = useState('low');
  const [time, setTime] = useState('');

  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    props.onSubmit({
      id: Math.floor(Math.random() * 10000),
      text: input,
      priority: priority,
      time: time,
      isComplete: false
    });

    setInput('');
    setPriority('low');
    setTime('');
  };

  return (
    <form className='form-container' onSubmit={handleSubmit}>
      {props.edit ? (
        <>
          <input
            type='text'
            placeholder='Update your task'
            value={input}
            name='text'
            className='todo-input'
            onChange={e => setInput(e.target.value)}
            ref={inputRef}
          />
          <button className='todo-button'>Update</button>
        </>
      ) : (
        <>
          <input
            type='text'
            placeholder='Add a task'
            value={input}
            name='text'
            className='todo-input'
            onChange={e => setInput(e.target.value)}
            ref={inputRef}
          />
          <select
            className='priority-select'
            value={priority}
            onChange={e => setPriority(e.target.value)}
          >
            <option value='low'>Low Priority</option>
            <option value='medium'>Medium Priority</option>
            <option value='high'>High Priority</option>
          </select>
          <input
            type='time'
            className='time-input'
            value={time}
            onChange={e => setTime(e.target.value)}
          />
          <button className='todo-button'>Add Task</button>
        </>
      )}
    </form>
  );
}

export default TodoForm; 